<template>
  <section class="box open-box"
           :class="is_opened ? 'is-opened':''">
    <div class="box-header">
      <div class="box-header-item">
        <h3>Add your private photos</h3>
        <span>Only you can see them and you can send them in messages</span>
      </div>
      <div class="box-header-item">
        <button type="button" class="button-link button-link-add prevent-click" @click="Photo_File_Add"><i></i><span>Add photo</span></button>
        <div class="close-btn" @click="ToggleOpened"></div>
      </div>
    </div>
    <div class="box-content">
      <ul class="media-list media-photo">
        <template v-for="(value, index) in photos" v-bind:key="index">
          <photo-list-element :photo="value" :index="index" :private="true"/>
        </template>
      </ul>
    </div>
  </section>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import PhotoListElement from "../../Misc/PhotoListElement";

export default {
  name: "UP_PrivatePhotos",
  components: {
    PhotoListElement
  },
  data: () => {
    return {
      is_opened: false,
    }
  },
  computed: {
    ...mapState({
      photos: state => state.User.user_data.private_photos,
    }),
  },

  methods: {
    ...mapMutations(['SetPopupData',]),
    GoToPreview() {

    },
    Photo_File_Add() {
      this.SetPopupData({
        private_flag: true,
        popup_name: 'add_photo_private',
        popup_opened: true
      })
    },
    ToggleOpened() {
      this.is_opened = !this.is_opened;
    },
  },
}
</script>

<style scoped>

</style>